import React from 'react'
import { Loading } from 'common'

import './styles.sass'

interface TableLoadingProps {
	number?: number
}

const TableLoading: React.FC<TableLoadingProps> = ({ number = 10 }: TableLoadingProps) => {
	return (
		<div>
			{[...Array(number)].map((_, idx) => (
				<div key={idx}>
					<Loading variant='rect' className='LoadingTableRow' />
				</div>
			))}
		</div>
	)
}

export default TableLoading
